export default __webpack_public_path__ + "3402cac2ed2db8bf8734b9d394d67513.svg";